module.exports = "<style></style> <h1>${this.podaci.naslov}</h1> <div> <img class=full src=${this.podaci.slika} alt=slika> </div> <p>${this.podaci.opis}</p> <p>${this.podaci.pitanje}</p> <div class=\"tri-dugmeta centar\"> ${this.izbori} </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/komponente/izbor/sablon.html
// module id = 34
// module chunks = 0